module.exports = __webpack_public_path__ + "static/media/sh_ci.19760afc.svg";